import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';
import type { FetchError } from '@atlassian/jira-fetch';
import {
	type UIAnalyticsEvent,
	type AnalyticsAttributes,
	fireUIAnalytics,
	fireOperationalAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import {
	API_FAIL,
	API_SUCCESS,
	GET_USER_PROPERTY_API_CALL,
	SEND_OPERATIONAL_EVENT,
	SET_USER_PROPERTY_API_CALL,
	TOUCHPOINT_NAME,
} from '../constants';

type ExtraPayload = Partial<Record<string, unknown>>;

export const fireButtonAnalytics = (
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
	actionSubjectId: string,
	attributes?: AnalyticsAttributes,
) => {
	fireUIAnalytics(
		createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'button',
		}),
		actionSubjectId,
		{
			upgradeOnboardingExperiment: true,
			...attributes,
		},
	);
};

export const fireGetUserPropertyFailEvent = (
	error: FetchError,
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
	payload?: ExtraPayload,
) => {
	const analyticsGetFailEvent = createAnalyticsEvent({
		type: SEND_OPERATIONAL_EVENT,
		action: API_FAIL,
		actionSubject: GET_USER_PROPERTY_API_CALL,
	});
	fireOperationalAnalytics(analyticsGetFailEvent, `${GET_USER_PROPERTY_API_CALL} ${API_FAIL}`, {
		growthFeature: TOUCHPOINT_NAME,
		errorMessage: error.message,
		errorStatus: error.statusCode,
		...payload,
	});
};

export const fireGetUserPropertySuccessEvent = (
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
	payload?: ExtraPayload,
) => {
	const analyticsGetSuccessEvent = createAnalyticsEvent({
		type: SEND_OPERATIONAL_EVENT,
		action: API_SUCCESS,
		actionSubject: GET_USER_PROPERTY_API_CALL,
	});
	fireOperationalAnalytics(
		analyticsGetSuccessEvent,
		`${GET_USER_PROPERTY_API_CALL} ${API_SUCCESS}`,
		{
			growthFeature: TOUCHPOINT_NAME,
			...payload,
		},
	);
};

export const fireSetUserPropertyFailEvent = (
	error: FetchError,
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
	payload?: ExtraPayload,
) => {
	const analyticsSetFailEvent = createAnalyticsEvent({
		type: SEND_OPERATIONAL_EVENT,
		action: API_FAIL,
		actionSubject: SET_USER_PROPERTY_API_CALL,
	});
	fireOperationalAnalytics(analyticsSetFailEvent, `${SET_USER_PROPERTY_API_CALL} ${API_FAIL}`, {
		growthFeature: TOUCHPOINT_NAME,
		errorMessage: error.message,
		errorStatus: error.statusCode,
		...payload,
	});
};

export const fireSetUserPropertySuccessEvent = (
	createAnalyticsEvent: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
	payload?: ExtraPayload,
) => {
	const analyticsSetSuccessEvent = createAnalyticsEvent({
		type: SEND_OPERATIONAL_EVENT,
		action: API_SUCCESS,
		actionSubject: SET_USER_PROPERTY_API_CALL,
	});
	fireOperationalAnalytics(
		analyticsSetSuccessEvent,
		`${SET_USER_PROPERTY_API_CALL} ${API_SUCCESS}`,
		{
			growthFeature: TOUCHPOINT_NAME,
			...payload,
		},
	);
};
